import { Group } from '../../app/users/+users/add-user/shared/models/group.model';


export class User {
  originalData: any;
  infosConsultant: any;
  consultantSheet: any;

  constructor(data) {
    this.originalData = data;
    if (!data.capabilities) {
      data.capabilities = {};
    }

    this.avatarId = data.avatarId;
    this.company = data.company;
    this.email = data.email;
    this.emailFeedDisabled = data.emailFeedDisabled;
    this.emailNotificationEnabled = data.emailNotificationEnabled;
    this.enabled = data.enabled;
    this.firstname = data.firstname || data.firstName || '';
    this.lastname = data.lastname || data.lastName || '';
    this.id = data.id;
    this.completeName = this.firstname + ' ' + this.lastname;
    this.isAdmin = data.capabilities.isAdmin;
    this.isGuest = data.capabilities.isGuest;
    this.isMutable = data.capabilities.isMutable;
    this.role = data.role || null;
    this.datas = {
      loadingPermissionChange: false
    };
    this.groups = data._groups || [];
    this.isManager = false;
    this.isClient = false;
    this.isCommercial = false;
    this.isConsultant = false;
    this.isExternal = false;
    this.srcImage = null;
    this.nodeRef = data.nodeRef;
  }

  private _avatarId: string;

  get avatarId(): any {
    return this._avatarId;
  }

  set avatarId(value: any) {
    this._avatarId = value;
  }

  private _company: any;

  get company(): any {
    return this._company;
  }

  set company(value: any) {
    this._company = value;
  }

  private _email: string;

  get email(): string {
    return this._email;
  }

  set email(value: string) {
    this._email = value;
  }

  private _emailNotificationEnabled: boolean;

  get emailNotificationEnabled(): boolean {
    return this._emailNotificationEnabled;
  }

  set emailNotificationEnabled(value: boolean) {
    this._emailNotificationEnabled = value;
  }

  private _emailFeedDisabled: boolean;

  get emailFeedDisabled(): boolean {
    return this._emailFeedDisabled;
  }
  set emailFeedDisabled(value: boolean) {
    this._emailFeedDisabled = value;
  }
  private _enabled: boolean;

  get enabled(): boolean {
    return this._enabled;
  }

  set enabled(value: boolean) {
    this._enabled = value;
  }

  private _firstname: string;

  get firstname(): string {
    return this._firstname;
  }

  set firstname(value: string) {
    this._firstname = value;
  }

  private _lastname: string;

  get lastname(): string {
    return this._lastname;
  }

  set lastname(value: string) {
    this._lastname = value;
  }

  public _id: string;

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  private _completeName: string;

  get completeName(): string {
    return this._completeName;
  }

  set completeName(value: string) {
    this._completeName = value;
  }

  private _isAdmin: boolean;

  get isAdmin(): boolean {
    return this._isAdmin;
  }

  set isAdmin(value: boolean) {
    this._isAdmin = value;
  }

  private _isExternal: boolean;

  get isExternal(): boolean {
    return this._isExternal;
  }

  set isExternal(value: boolean) {
    this._isExternal = value;
  }

  private _isGuest: boolean;

  get isGuest(): boolean {
    return this._isGuest;
  }

  set isGuest(value: boolean) {
    this._isGuest = value;
  }

  private _isMutable: boolean;

  get isMutable(): boolean {
    return this._isMutable;
  }

  set isMutable(value: boolean) {
    this._isMutable = value;
  }

  private _role: string;

  get role(): string {
    return this._role;
  }

  set role(value: string) {
    this._role = value;
  }

  private _datas: any;

  get datas(): any {
    return this._datas;
  }

  set datas(value: any) {
    this._datas = value;
  }

  private _groups: Group[];

  get groups(): Group[] {
    return this._groups;
  }

  set groups(value: Group[]) {
    this._groups = value;
  }

  private _isManager: boolean;

  get isManager(): boolean {
    return this._isManager;
  }

  set isManager(value: boolean) {
    this._isManager = value;
  }

  private _isClient: boolean;

  get isClient(): boolean {
    return this._isClient;
  }

  set isClient(value: boolean) {
    this._isClient = value;
  }

  private _isCommercial: boolean;

  get isCommercial(): boolean {
    return this._isCommercial;
  }

  set isCommercial(value: boolean) {
    this._isCommercial = value;
  }

  private _isConsultant: boolean;

  get isConsultant(): boolean {
    return this._isConsultant;
  }

  set isConsultant(value: boolean) {
    this._isConsultant = value;
  }

  private _srcImage: any;

  get srcImage(): any {
    return this._srcImage;
  }

  set srcImage(value: any) {
    this._srcImage = value;
  }

  private _urlImage: any;

  public get urlImage(): any {
    return this._urlImage;
  }

  public set urlImage(value: any) {
    this._urlImage = value;
  }

  private _nodeRef: any;

  get nodeRef(): any {
    return this._nodeRef;
  }

  set nodeRef(value: any) {
    this._nodeRef = value;
  }
}
